import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid, scopedCssBaselineClasses } from '@mui/material'
import { findCode, printVariable } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import useAlert from '@hooks/useAlert'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import Box from '@mui/material/Box'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import '@scss/App.scss'
import consoleLogger from 'react-terminal-logger/console-logger'
import CloseIcon from '@mui/icons-material/Close'
import TeacherAttdncPartNoti from './teacher-attdnc.part.noti'
import TeacherAttdncPartCare from './teacher-attdnc.part.care'
import TeacherMessagePartPost from './teacher-message.part.post'
import { useTheme } from '@mui/material/styles';
const TeacherAttdncPartBing = ({ record, dialogHandler, tabValue, callback }) => {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [dataList, set_dataList] = React.useState([])
  const [dateTime, set_dateTime] = React.useState({})
  const [attdnc, set_attdnc] = React.useState({})
  const lschsRef = useRef()
  const [topicCode, set_topicCode] = useState('')
  // redux
  const codes = useSelector((state) => state.codeReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const notiHandler = useState(false)
  const careHandler = useState(false)
  const postHandler = useState(false)
  const [chgBings, set_chgBings] = useState([])
  const statCodes = codes.filter((r) => r.codeGroupId === 'SA10')
  const chgCodes = codes.filter((r) => r.codeGroupId === 'SB10')
  const originDataRef = useRef([])
  const recordRef = useRef(null)
  const statCodeRef = useRef(null)
  const buttonRef = useRef(null)
  const theme = useTheme()
  const fields = [
    { field: 'id', placeholder: '', type: 'text', value: -1, visible: false, canSrch: false, selList: [] },
    { field: 'indexing', placeholder: 'No.', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'schoolId', placeholder: '학교명', type: 'auto', value: '', visible: false, canSrch: true, selList: [] },
    { field: 'grade', placeholder: '학년', type: 'number', value: '', visible: true, canSrch: true, selList: [] },
    { field: 'className', placeholder: '반', type: 'text', value: '', visible: true, canSrch: true, selList: [] },
    { field: 'classNum', placeholder: '번호', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'name', placeholder: '이름', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'gdnPhone', placeholder: '보호자 전화 번호', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'offCodeName', placeholder: '귀가방법', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'statName', placeholder: '출결상태', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'chgName', placeholder: '이동상태', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
    { field: 'startmYn', placeholder: '출결알림', type: 'number', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'endmYn', placeholder: '종료알림', type: 'number', value: '', visible: false, canSrch: false, selList: [] },
    { field: 'care', placeholder: '보호자알림', type: 'text', value: '', visible: tabValue === '1' ? true : false, canSrch: false, selList: [] },
  ]

  const weekCode = { 1: '월', 2: '화', 3: '수', 4: '목', 5: '금', 6: '토', 7: '일' }

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      dialogHandler[1](false)
    }
  }

  const parseData = (report, lschs) => {
    const students = report.students
    const bings = report.bings
    const regis = report.regis

    if (!report.attdnc) {
      alert('데이터가 없습니다.')
      return
    }

    for (const [idx, student] of students.entries()) {
      const bing = bings[idx]
      student.statCode = bing.statCode
      student.statName = findCode(codes, 'SA10', bing.statCode)?.name ?? ''
      student.chgCode = bing.chgCode
      student.chgName = findCode(codes, 'SB10', bing.chgCode)?.name ?? ''
      student.startmYn = bing.startmYn ?? ''
      student.endmYn = bing.endmYn ?? ''
      student.userYn = bing.userYn ?? ''
      student.bingId = bing.id

      student.offCode = regis.find((r) => r.studentId == student.id)?.offCode ?? ''
      student.offCodeName = findCode(codes, 'SA29', student.offCode)?.name ?? ''

      // 강사 PC 화면 저장하기 위해서, BingsRow 형태로 맞춰줌
      student.studentId = student.id
      student.attdncId = bing.attdncId
      student.chgCode = bing.chgCode ?? ''
      student.remark = bing.remark ?? ''
      student.uptTime = bing.uptTime
      student.regTime = bing.regTime
      student.studentName = student.name
      student.title = record.title // 강좌명
      student.lectureId = record.id // 강좌명

    }

    /* TODO, 위에 학생 데이터를 메인으로 하여 너무 bingId 관련 너무 쓸데 없이 복잡해 져서 아래 소스 변경하기 위해 일단 작성해 둠.
    for (const [idx, bing] of bings.entries()) {

      const student = students[idx]
      bing.statName = findCode(codes, 'SA10', bing.statCode)?.name ?? ''
      bing.chgName = findCode(codes, 'SB10', bing.chgCode)?.name ?? ''
      bing.bingId = bing.id

      bing.offCode = regis.find((r) => r.studentId == student.id)?.offCode ?? ''
      bing.offCodeName = findCode(codes, 'SA29', student.offCode)?.name ?? ''

      bing.className = student.className
      bing.classNum = student.classNum
      bing.grade = student.grade
      bing.gdnPhone = student.gdnPhone
      bing.studentName = student.name
      bing.title = record.title // 강좌명
      bing.lectureId = record.id // 강좌명
    }
    */


    originDataRef.current = JSON.parse(JSON.stringify(students))

    if (report.attdnc) {
      const attdnc = report.attdnc
      const dt = moment(attdnc.lectureTime, dateFormat)
      const idx = lschs.findIndex((r) => r.id === attdnc.lschId)

      const subDt = moment(attdnc.subLectureTime, dateFormat)
      const subDay = weekCode['' + subDt.day()]
      const subStartTime = moment(attdnc.subStartTime, 'HH:mm')
      const subEndTime = moment(attdnc.subEndTime, 'HH:mm')

      if (idx >= 0) {
        const startTime = lschs[idx].startTime
        const endTime = lschs[idx].endTime

        const dateTime = {
          date: dt.format('YYYY-MM-DD'),
          day: weekCode['' + dt.day()],
          startTime: startTime,
          endTime: endTime,

          subDate: subDt.format('YYYY-MM-DD'),
          subDay: subDay,
          subStartTime: subStartTime.format('HH:mm'),
          subEndTime: subEndTime.format('HH:mm'),
        }
        set_dateTime(dateTime)
        set_attdnc(attdnc)
      }

      // 강사가 아직 출석부를 작성하지 않은 상태, 기본값을 출석으로 셋팅
      if(attdnc.userYn === 'N') {
        students.filter(r => r.statCode === 'S000').forEach(r => {
          r.statCode = 'S001'
          r.statName = findCode(codes, 'SA10', 'S001')?.name ?? ''
        })
      }
      set_dataList(students)
    }
  }

  const onLoad = async () => {
    openIndicator()
    const report = await fetchBings()
    const lschs = await fetchLschs()
    lschsRef.current = lschs

    parseData(report, lschsRef.current)

    closeIndicator()
  }

  const fetchBings = async (attdncId, direction) => {
    openIndicator()
    const url = `/attdnc/single/lecture/${record.id}`
    const params = { attdncId: attdncId, direction: direction }
    const resp = await WebService.get(url, params)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const respMessage = JSON.parse(resp.repMessage)
    return JSON.parse(respMessage.report)
  }

  const fetchForward = async () => {
    const report = await fetchBings(attdnc?.id, 'forward')
    parseData(report, lschsRef.current)
  }

  const fetchBackward = async () => {
    const report = await fetchBings(attdnc?.id, 'backward')
    parseData(report, lschsRef.current)
  }

  const fetchLschs = async () => {
    const url = `/lsch/lecture/${record.id}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const respMessage = JSON.parse(resp.repMessage)
    return JSON.parse(respMessage.records)
  }

  const genBings = () => {
    const bings = dataList.map((d) => {
      return {
        id: d.bingId,
        attdncId: d.attdncId,
        studentId: d.studentId,
        statCode: d.statCode,
        chgCode: d.chgCode,
        userYn: 'Y',
        startmYn: d.startmYn,
        endmYn: d.endmYn,
        remark: d.remark,
        uptTime: moment().format(dateFormat),
        regTime: d.regTime,
        // 이하 조회용 학생 추가 정보
        studentName: d.name,
        grade: d.grade,
        className: d.className,
        classNum: d.classNum,
      }
    })
    return bings
  }

  const saveBings = async () => {
    const bings = genBings()

    const S000 = bings.filter((d) => d.statCode === 'S000')
    if (S000.length > 0) {
      alert('출석상태가 미정인 학생이 있어 저장할 수 없습니다.')
      return
    }
    const url = encodeURI(`/bing`)

    const body = {
      bingList: JSON.stringify(bings),
    }

    const resp = await WebService.post(url, body, {
      matchDate: 'Y',
      schoolId: schola.id,
    })

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    return true
  }

  const onSave = async () => {
    openIndicator()
    const ret = await saveBings()
    
    closeIndicator()
    if (ret) {
      alert('저장되었습니다.')
    }
  }

  const onSendMessage = async() => {
    const ret = await saveBings()
    if(!ret) {
      return
    }
    const url = encodeURI(`/topic/${schola.id}/${topicCode}`)
    const params = {
      lectureId: record.id,
      matchDate: 'Y',
      chgBingIds: chgBings.map(r => r.bingId).join(',')
    }
    const body = genBings()
    openIndicator()
    const resp = await WebService.post(url, body, params)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('알림을 전송하였습니다.', async() => {
      if(topicCode === 'TP10') {
        set_chgBings([])
      }
      const report = await fetchBings()
      parseData(report, lschsRef.current)
      notiHandler[1](false)
    })
  }

  const showPost = () => {
    careHandler[1](false)
    postHandler[1](true)
  }

  const infoColor = (field) => {
    return field === 'Y' ? theme.palette.text.primary : theme.palette.error.main
  }
  React.useEffect(() => {
    if (dialogHandler[0]) {
      onLoad()
    }
  }, [dialogHandler[0]])

  return (
    <Fragment>
      {notiHandler[0] ? (
        <TeacherAttdncPartNoti genBings={genBings} topicCode={topicCode} chgBings={chgBings} 
        dialogHandler={notiHandler} onSendMessage={onSendMessage} callback={onLoad} />
      ) : null}
      {careHandler[0] ? <TeacherAttdncPartCare bing={recordRef.current} dialogHandler={careHandler} showPost={showPost} callback={onLoad} /> : null}
      {postHandler[0] ? (
        <TeacherMessagePartPost dialogHandler={postHandler} tid={recordRef.current.lectureId} sid={recordRef.current.studentId} msgType="push" />
      ) : null}
      {/* <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='lg' fullWidth> */}
      <Dialog open={dialogHandler[0]} onClose={handleClose} fullScreen>
        <DialogTitle>
          {/*<Box sx={{display:'center', justifyContent:'center', alignItems:'center'}}>*/}
          <Grid container>
            <Grid item xs></Grid>
            <Grid item xs={10}>
              <Box className={'center'}>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  {schola.name}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }} align="center">
                  {record.title}
                </Typography>
                <Typography variant="h5" sx={{ margin: 1 }}>
                  {' '}
                  출석부
                </Typography>
              </Box>
            </Grid>
            <Grid item xs style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

          <Divider></Divider>
        </DialogTitle>
        <DialogContent sx={{ minHeight: '50vh' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 1 }}>
            <Button variant="text" onClick={() => fetchBackward()}>
              <ArrowBackIosNewOutlinedIcon />
            </Button>
            <Typography style={{ textDecoration: dateTime.subDay ? 'line-through' : null }}>
              {dateTime.date}, {dateTime.day}, {dateTime.startTime} ~ {dateTime.endTime}
            </Typography>
            {dateTime.subDay ? (
              <Typography style={{ marginLeft: 10 }}>
                --&gt; {dateTime.subDate}, {dateTime.subDay}, {dateTime.subStartTime} ~ {dateTime.subEndTime}
              </Typography>
            ) : null}
            <Button variant="text" onClick={() => fetchForward()}>
              <ArrowForwardIosOutlinedIcon />
            </Button>
          </Box>

          <div
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              margin: 1,
              justifyContent: 'space-evenly',
              flexDirection: 'row',
              marginBottom: 10,
              height: '2em',
              backgroundColor: attdnc.userYn === 'Y' && attdnc.startmYn === 'Y' && attdnc.endmYn === 'Y' ? gs.colors.attdncGood : gs.colors.attdncBad,
            }}
          >
            <Typography style={{fontWeight:'bold',  color: infoColor(attdnc.userYn)}}>출석부 저장 {attdnc.userYn === 'Y' ? 'Y' : 'N'}</Typography>
            <Typography style={{fontWeight:'bold',  color: infoColor(attdnc.startmYn)}}>출결알림 {attdnc.startmYn === 'Y' ? 'Y' : 'N'}</Typography>
            <Typography style={{fontWeight:'bold',  color: infoColor(attdnc.endmYn)}}>종료알림 {attdnc.endmYn === 'Y' ? 'Y' : 'N'}</Typography>
          </div>

          <MUITable>
            <MyTableHead>
              <TableRow>
                {fields.map((col, index) =>
                  col.visible ? (
                    <TableCell size="small" key={index}>
                      {col.placeholder}
                    </TableCell>
                  ) : null
                )}
              </TableRow>
            </MyTableHead>
            <TableBody>
              {dataList &&
                dataList.map((row, rowIdx) => {
                  return (
                    <TableRow
                      key={rowIdx}
                      style={{ backgroundColor: row.statCode.startsWith('X') ? '#ffebee' : null }}
                      onClick={() => (recordRef.current = row)}
                    >
                      {fields.map((col, colIdx) =>
                        col.visible ? (
                          col.field === 'indexing' ? (
                            <TableCell size="small">{rowIdx + 1}</TableCell>
                          ) : col.field === 'statName' ? (
                            <TableCell size="small">
                              {tabValue === '1' ? (
                                <FormControl fullWidth>
                                  <InputLabel id="statCode">출결상태</InputLabel>
                                  <Select
                                    labelId="statCode"
                                    required
                                    label="출결상태"
                                    name={'statCode'}
                                    value={row.statCode}
                                    disabled={row.statCode.startsWith('X')}
                                    onChange={async (e) => {
                                      const newDataList = [...dataList]
                                      const code = e.target.value
                                      newDataList[rowIdx].statCode = code
                                      newDataList[rowIdx].statName = findCode(codes, 'SA10', code)?.name ?? ''
                                      set_dataList(newDataList)
                                    }}
                                  >
                                    {statCodes.map((l, index) => (
                                      <MenuItem key={index} value={l.code} disabled={!l.code.startsWith('S') || l.code === 'S000'}>
                                        {l.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              ) : (
                                <Typography>{row.statName}</Typography>
                              )
                              }
                            </TableCell>
                          ) : col.field === 'chgName' ? (
                            <TableCell size="small">
                              {tabValue === '1' ? (
                                <FormControl fullWidth>
                                  <InputLabel id="chgCode">이동상태</InputLabel>
                                  <Select
                                    labelId="chgCode"
                                    required
                                    label="이동상태"
                                    name={'chgCode'}
                                    value={row.chgCode}
                                    style={{ backgroundColor: chgBings.findIndex((r) => r.bingId === row.bingId) >= 0 ? 'yellow' : null }}
                                    disabled={row.statCode.startsWith('X')}
                                    onChange={async (e) => {
                                      const newDataList = [...dataList]
                                      const code = e.target.value
                                      newDataList[rowIdx].chgCode = code
                                      newDataList[rowIdx].chgName = findCode(codes, 'SB10', code)?.name ?? ''
                                      set_dataList(newDataList)

                                      const idx = chgBings.findIndex((r) => r.bingId === row.bingId)
                                      if (idx >= 0) {
                                        chgBings.splice(idx, 1)
                                      }
                                      if (e.target.value !== 'C000') {
                                        const idx = originDataRef.current.findIndex((r) => r.bingId === row.bingId && r.chgCode === e.target.value)
                                        if (originDataRef.current.findIndex((r) => r.bingId === row.bingId && r.chgCode === e.target.value) < 0) {
                                          const newChgBings = [...chgBings, { ...row }]
                                          set_chgBings(newChgBings)
                                        }
                                      }
                                    }}
                                  >
                                    {chgCodes.map((l, index) => (
                                      <MenuItem key={index} value={l.code}>
                                        {l.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              ) : (
                                <Typography>{row.chgName}</Typography>
                              )}
                            </TableCell>
                          ) : col.field === 'care' ? (
                            <TableCell size="small" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                              <IconButton
                                edge="center"
                                color="success"
                                disabled={row.statCode.startsWith('X')}
                                onClick={() => {
                                  careHandler[1](true)
                                }}
                              >
                                <SendOutlinedIcon />
                              </IconButton>
                            </TableCell>
                          ) : (
                            <TableCell size="small">{row[col.field]}</TableCell>
                          )
                        ) : null
                      )}
                    </TableRow>
                  )
                })}
            </TableBody>
          </MUITable>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant="outlined" onClick={handleClose}>
            닫기
          </Button>
          {
            tabValue === '1' ? (
              <>
              <ConfirmDialog
            btn={<Button variant="contained">출석부저장</Button>}
            title={'출석부 저장'}
            bc={'primary'}
            content={'출석부를 저장하시겠습니까?'}
            preHandle={async () => {
              return true
            }}
            perform={async () => {
              await onSave()
            }}
          />

          <Button
            variant="contained"
            color="success"
            
            disabled={attdnc.startmYn === 'Y'}
            onClick={() => {
              set_topicCode('TP02')
              notiHandler[1](true)
            }}
          >
            출결알림
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={chgBings.length == 0}
            onClick={() => {
              set_topicCode('TP10')
              notiHandler[1](true)
            }}
          >
            이동알림
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={attdnc.userYn !== 'Y' || attdnc.startmYn !== 'Y' || attdnc.endmYn === 'Y'}
            onClick={() => {
              set_topicCode('TP03')
              notiHandler[1](true)
            }}
          >
            종료알림
          </Button>
              </>
            ) : null
          }
          
        </DialogActions>
      </Dialog>

      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default TeacherAttdncPartBing
